var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12517_487150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12517_487150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 19.1016H12.6V17.7516L16.2 14.1516V9.50156H7.8V14.1516L11.4 17.7516V19.1016ZM9.6 20.9016V18.5016L6 14.9016V9.50156C6 9.00656 6.17625 8.58281 6.52875 8.23031C6.88125 7.87781 7.305 7.70156 7.8 7.70156H9.15L8.4 8.80156V4.10156H10.2V7.70156H13.8V4.10156H15.6V8.80156L14.85 7.70156H16.2C16.695 7.70156 17.1188 7.87781 17.4713 8.23031C17.8238 8.58281 18 9.00656 18 9.50156V14.9016L14.4 18.5016V20.9016H9.6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.d129750a049eaff963c92fa0f19ca9b0.svg";
export { ForwardRef as ReactComponent };